<div class="application-outer">
  <form class="form" [formGroup]="form">
    <div class="self-scheduling-outer">
      <div class="self-scheduling-outer__content" formGroupName="general">
        <div class="self-scheduling-outer__online-configurations">
          <div class="self-scheduling-outer__online-booking">
            <div class="col">
              <div class="form__group">
                <label for="leadTime" class="form__label">Lead Time For Online Cancellations</label>
                <input type="number" name="leadTime" formControlName="leadTime" class="form__control" pInputText />
                <small>What is the minimum time (in hours) customers
                  can cancel before their scheduled Booking is due to start?
                </small>
              </div>

              <div class="form__group">
                <label for="numOfDays" class="form__label">Days for which booking can be done</label>
                <input type="number" name="numOfDays" formControlName="numOfDays" class="form__control" pInputText />
                <small>
                  How many days from today you want to schedule booking?
                </small>
              </div>

              <div class="form__group">
                <label for="unreconciled" class="form__label">Unreconciled</label>
                <input formControlName="unreconciled" name="unreconciled" type="number" class="form__control"
                  pInputText />
                <small>How many days until a booking is considered Unreconciled?</small>
              </div>

              <div class="form__group">
                <label for="displayNote" class="form__label">
                  Display "Delivery Note" on self-scheduling
                  <span
                    pTooltip="Delivery Note display on the appointment confirmation page and on the page where it shows existing appointment booked (same link of the self-scheduling)">
                    <i class="info-new" style="margin-bottom: -4px;"></i>
                  </span>
                </label>
                <div class="radios">
                  <span class="form__radio-outer">
                    <p-radioButton class="form__radio-button" name="displayNote" formControlName="displayNote"
                      [value]="true" label="Yes" inputId="DeliveryYes"></p-radioButton>
                    <label class="radio-button-text" for="DeliveryYes">Yes</label>
                  </span>
                  <span class="form__radio-outer">
                    <p-radioButton class="form__radio-button" name="displayNote" formControlName="displayNote"
                      [value]="false" label="No" inputId="DeliveryNo"></p-radioButton>
                    <label class="radio-button-text" for="DeliveryNo">No</label>
                  </span>
                </div>
              </div>

              <div class="form__group">
                <label for="displayDueAmount" class="form__label">Display patient’s due amount (On homepage)</label>
                <div class="radios">
                  <span class="form__radio-outer">
                    <p-radioButton name="displayDueAmount" formControlName="displayDueAmount" [value]="true" label="Yes"
                      inputId="patientYes"></p-radioButton>
                    <label class="radio-button-text" for="patientYes">Yes</label>
                  </span>
                  <span class="form__radio-outer">
                    <p-radioButton name="displayDueAmount" formControlName="displayDueAmount" [value]="false" label="No"
                      inputId="patientNo"></p-radioButton>
                    <label class="radio-button-text" for="patientNo">No</label>
                  </span>
                </div>
              </div>

              <div class="form__group">
                <label for="displayNameOfFacilityAppointment" class="form__label">Display name of appointment</label>
                <div *ngFor="let label  of model?.setup?.labels" class="form__group enable-remote">
                  <div class="clearfix" style="max-width: 100%; width: 100%;"></div>
                  <div class="full-width">
                    <div class="input-edit-table" [class.edit-box]="label.isEditMode">
                      <input type="text" [(ngModel)]="label.value" (ngModelChange)="onLabelChange(label)"
                        [ngModelOptions]="{standalone: true}" [placeholder]="label.defaultValue" class="form__control"
                        pInputText maxlength="100" />
                      <div class="action-icon">
                        <a class="edit-icon" (click)="label.isEditMode=true">
                          <i class="edit-icon-new"></i>
                        </a>
                        <a class="save-icon" (click)="label.isEditMode=false">
                          <i class="ic check-ic-small"></i>
                        </a>
                        <a class="cancel-icon" (click)="!label.isEditMode=false">
                          <i class="ic cancel-ic-small"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--<div class="form__group">
                <label for="expiryPeriodAppointmentLink" class="form__label">Expiry Period of Appointment Link</label>
                <div class="radios">
                  <span class="form__radio-outer">
                    <p-radioButton name="expiryPeriodAppointmentLink" formControlName="expiryPeriodAppointmentLink" [value]="false"
                      label="No" inputId="appointmentLinkNo"></p-radioButton>
                    <label class="radio-button-text" for="appointmentLinkNo">Never Expire</label>
                    </span>
                    <span class="form__radio-outer">
                    <p-radioButton name="expiryPeriodAppointmentLink" formControlName="expiryPeriodAppointmentLink" [value]="true"
                    label="Yes" inputId="appointmentLinkYes"></p-radioButton>
                    <label class="radio-button-text" for="appointmentLinkYes">Expire after specified time</label>
                  </span>
                </div>
              </div>
               <ng-container *ngIf="form.get('general.expiryPeriodAppointmentLink')?.value">
                  <div class="appointment-block-box">
                    <div class="form__group">
                     <p-select [disabled]="" class="form__dropdown select-box" placeholder="Select Expiry Period" optionLabel="title"
                        formControlName="expiryPeriod" name="expiryPeriod" optionLabel="title" optionValue="value"
                        [options]="expiryPeriodOptions">
                      </p-select>
                      <input formControlName="expiryPeriodDuration" name="expiryPeriodDuration" type="number" class="form__control"
                  pInputText />
                    </div>
                    
                  </div>
                </ng-container> -->

              <div class="form__group full-width">
                <label for="expiryPeriodAppointmentLink" class="form__label">Expire Period of Self Scheduling
                  Appointment Link</label>
                <div class="radios">
                  <span class="form__radio-outer">
                    <p-radioButton name="expiryPeriodAppointmentLink" formControlName="expiryPeriodAppointmentLink"
                      [value]="true" label="Yes" inputId="appointmentLinkYes"></p-radioButton>
                    <label class="radio-button-text" for="appointmentLinkYes">Expire after specified time</label>
                  </span>
                  <span class="form__radio-outer">
                    <p-radioButton name="expiryPeriodAppointmentLink" formControlName="expiryPeriodAppointmentLink"
                      [value]="false" label="No" inputId="appointmentLinkNo"></p-radioButton>
                    <label class="radio-button-text" for="appointmentLinkNo">Never Expire</label>
                  </span>
                </div>
                <!-- Add validation message for radio button -->
                <div class="form__error"
                  *ngIf="form.get('general.expiryPeriodAppointmentLink')?.invalid && form.get('general.expiryPeriodAppointmentLink')?.touched">
                  <span *ngIf="form.get('general.expiryPeriodAppointmentLink')?.errors?.['required']">
                    Please select an expiry option
                  </span>
                </div>
              </div>

              <ng-container *ngIf="form.get('general.expiryPeriodAppointmentLink')?.value">
                <div class="appointment-block-box">
                  <div class="form__group expiry-period-group ">
                    <div class="form-input-select">
                      <p-select class="form__dropdown select-box" placeholder="Select Expiry Period" optionLabel="title"
                        formControlName="expiryPeriod" name="expiryPeriod" optionLabel="title" optionValue="value"
                        [class.is-invalid]="form.get('general.expiryPeriod')?.invalid && form.get('general.expiryPeriod')?.touched"
                        [options]="expiryPeriodOptions">
                      </p-select>

                      <div class="form__error"
                        *ngIf="form.get('general.expiryPeriod')?.invalid && form.get('general.expiryPeriod')?.touched">
                        <span *ngIf="form.get('general.expiryPeriod')?.errors?.['required']">
                          Please select an expiry period
                        </span>
                      </div>

                    </div>
                    <div class="form-input">
                      <input formControlName="expiryPeriodDuration" name="expiryPeriodDuration" type="number"
                        class="form__control"
                        [class.is-invalid]="form.get('general.expiryPeriodDuration')?.invalid && form.get('general.expiryPeriodDuration')?.touched"
                        placeholder="Enter duration" pInputText />


                      <div class="form__error"
                        *ngIf="form.get('general.expiryPeriodDuration')?.invalid && form.get('general.expiryPeriodDuration')?.touched">
                        <span *ngIf="form.get('general.expiryPeriodDuration')?.errors?.['required']">
                          Duration value is required
                        </span>
                        <span *ngIf="form.get('general.expiryPeriodDuration')?.errors?.['onlyNumbers']">
                          Only numbers are allowed
                        </span>
                        <span
                          *ngIf="form.get('general.expiryPeriodDuration')?.errors?.['min'] && form.get('general.expiryPeriod')?.value === 'Minutes'">
                          Minutes must be between 1 and 59
                        </span>
                        <span
                          *ngIf="form.get('general.expiryPeriodDuration')?.errors?.['max'] && form.get('general.expiryPeriod')?.value === 'Minutes'">
                          Minutes must be between 1 and 59
                        </span>
                        <span
                          *ngIf="form.get('general.expiryPeriodDuration')?.errors?.['min'] && form.get('general.expiryPeriod')?.value === 'Hours'">
                          Hours must be between 1 and 23
                        </span>
                        <span
                          *ngIf="form.get('general.expiryPeriodDuration')?.errors?.['max'] && form.get('general.expiryPeriod')?.value === 'Hours'">
                          Hours must be between 1 and 23
                        </span>
                        <span
                          *ngIf="form.get('general.expiryPeriodDuration')?.errors?.['min'] && form.get('general.expiryPeriod')?.value === 'Days'">
                          Days must be between 1 and 365
                        </span>
                        <span
                          *ngIf="form.get('general.expiryPeriodDuration')?.errors?.['max'] && form.get('general.expiryPeriod')?.value === 'Days'">
                          Days must be between 1 and 365
                        </span>
                      </div>
                    </div>

                  </div>

                  <!-- Validation messages for duration value -->


                  <!-- Validation messages for duration period -->

                </div>
              </ng-container>

            </div>
          </div>

          <div class="self-scheduling-outer__default-duration">
            <div class="full-width">
              <div class="form__group">
                <label for="slotDuration" class="form__label">Default duration of appointment slots</label>
                <p-select [disabled]="" class="form__dropdown select-box" placeholder="Select Duration"
                  optionLabel="title" formControlName="slotDuration" name="slotDuration" optionLabel="title"
                  optionValue="value" [options]="classificationDurationOptions">
                </p-select>
              </div>
            </div>
            <div class="full-width">
              <div class="form__group">
                <label for="slotBasedOnClassification" class="form__label">Appointment slots (Based on the
                  classification)</label>
                <div class="radios">
                  <span class="form__radio-outer">
                    <p-radioButton name="slotBasedOnClassification" formControlName="slotBasedOnClassification"
                      [value]="true" label="Yes" inputId="slotBasedOnClassification"></p-radioButton>
                    <label class="radio-button-text" for="slotBasedOnClassification">Yes</label>
                  </span>
                  <span class="form__radio-outer">
                    <p-radioButton name="slotBasedOnClassification" formControlName="slotBasedOnClassification"
                      [value]="false" label="No" inputId="slotBasedOnClassification"></p-radioButton>
                    <label class="radio-button-text" for="slotBasedOnClassification">No</label>
                  </span>
                </div>
                <small>The slots will be displayed based on<br>the classification available in the sales orders.</small>
              </div>
            </div>
          </div>


          <div *ngIf="isGroupAppointmentFeatureSubscribed" class="self-scheduling-outer__default-duration">
            <div class="full-width">
              <div class="form__group">
                <span class="switchBtn">
                  <p-inputSwitch class="form__switch" name="enableGroupSession" formControlName="enableGroupSession"
                    binary="true"></p-inputSwitch>
                  Enable group session appointment for patient
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="self-scheduling-outer__self-scheduling-configurations">
        <h2>Self-scheduling Configuration</h2>
        <div class="full-width" formGroupName="selfScheduleOption">
          <div class="form__group">
            <label for="isEnabled" class="form__label">Default self-scheduling</label>
            <div class="radios">
              <span class="form__radio-outer">
                <p-radioButton name="isEnabled" formControlName="isEnabled" [value]="true" label="Yes"
                  inputId="schedulingYes"></p-radioButton>
                <label class="radio-button-text" for="schedulingYes">Yes</label>
              </span>
              <span class="form__radio-outer">
                <p-radioButton name="isEnabled" formControlName="isEnabled" [value]="false" label="No"
                  inputId="schedulingNo"></p-radioButton>
                <label class="radio-button-text" for="schedulingNo">No</label>
              </span>
            </div>
          </div>
        </div>
        <ng-container *ngIf="form.get('selfScheduleOption.isEnabled')?.value">
          <label for="isEnabled" class="form__label">{{defaultTemplate}}</label>

          <div class="self-scheduling-outer__preview-btns">
            <a href="javascript:void(0);" class="btn btn--preview-btn" (click)="EmailPreviewClick()">
              <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.5627 7.30533C12.5627 8.83288 11.3243 10.0711 9.79685 10.0711C8.2693 10.0711 7.03101 8.83288 7.03101 7.30533C7.03101 5.77777 8.2693 4.53952 9.79685 4.53952C11.3243 4.53952 12.5627 5.77777 12.5627 7.30533Z"
                  stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M1 7.3053C2.1748 3.56489 5.6692 0.851746 9.79729 0.851746C13.9254 0.851746 17.4198 3.56492 18.5946 7.3053C17.4198 11.0457 13.9254 13.7589 9.79729 13.7589C5.66919 13.7589 2.17478 11.0457 1 7.3053Z"
                  stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>

              Preview Email
            </a>
            <a href="javascript:void(0);" class="btn btn--preview-btn" (click)="SMSPreviewClick()">
              <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.5627 7.30533C12.5627 8.83288 11.3243 10.0711 9.79685 10.0711C8.2693 10.0711 7.03101 8.83288 7.03101 7.30533C7.03101 5.77777 8.2693 4.53952 9.79685 4.53952C11.3243 4.53952 12.5627 5.77777 12.5627 7.30533Z"
                  stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M1 7.3053C2.1748 3.56489 5.6692 0.851746 9.79729 0.851746C13.9254 0.851746 17.4198 3.56492 18.5946 7.3053C17.4198 11.0457 13.9254 13.7589 9.79729 13.7589C5.66919 13.7589 2.17478 11.0457 1 7.3053Z"
                  stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              Preview SMS
            </a>
          </div>

          <div class="self-scheduling-outer__appointmetn-box" formGroupName="selfScheduling">
            <div class="col">
              <label for="isFreshRemoteTypeAppointment" class="form__label full-width">Default appointment options for
                Fresh appointments</label>
              <div class="form__group">
                <div class="input-edit-table form__checkbox-outer">
                  <p-checkbox class="form__checkbox" name="isFreshRemoteTypeAppointment"
                    formControlName="isFreshRemoteTypeAppointment" binary="true" label="Remote"
                    inputId="isFreshRemoteTypeAppointment"></p-checkbox>
                  <label class="checkbox-text" for="isFreshRemoteTypeAppointment">({{optionalOnlineLabel}})</label>
                </div>
              </div>
              <div class="form__group">
                <div class="input-edit-table form__checkbox-outer">
                  <p-checkbox name="isFreshFacilityTypeAppointment" formControlName="isFreshFacilityTypeAppointment"
                    binary="true" label="Facility" inputId="isFreshFacilityTypeAppointment"></p-checkbox>
                  <label class="checkbox-text" for="isFreshFacilityTypeAppointment">({{optionalFacilityLabel}})</label>
                </div>
              </div>
            </div>
            <div class="col">
              <label for="isCancellationAllowed" class="form__label full-width">Allow Reschedule & Cancel
                appointment</label>
              <div class="form__group">
                <div class="input-edit-table form__checkbox-outer">
                  <p-checkbox name="isCancellationAllowed" formControlName="isCancellationAllowed" binary="true"
                    label="Cancel Appointment" inputId="isCancellationAllowed"></p-checkbox>
                  <label class="checkbox-text" for="isCancellationAllowed">Cancel Appointment</label>
                </div>

                <ng-container *ngIf="form.get('selfScheduling.isCancellationAllowed')?.value">
                  <div class="appointment-block-box">
                    <div class="form__group">
                      <label for="isLimitNoOfCancelAppointments" class="form__label">Limit no. of attempts</label>
                      <div class="radios">
                        <div class="input-edit-table form__radio-outer">
                          <p-radioButton name="isLimitNoOfCancelAppointments"
                            formControlName="isLimitNoOfCancelAppointments" [value]="true" label="Yes"
                            inputId="LimitYes"></p-radioButton>
                          <label class="radio-button-text" for="LimitYes">(Fixed)</label>
                        </div>
                        <div class="input-edit-table form__radio-outer">
                          <p-radioButton name="isLimitNoOfCancelAppointments"
                            formControlName="isLimitNoOfCancelAppointments" [value]="false" label="No"
                            inputId="LimitNo"></p-radioButton>
                          <label class="radio-button-text" for="LimitNo">(Unlimited)</label>
                        </div>
                      </div>
                    </div>
                    <div class="form__group allowed" style="margin-bottom: -1.5rem"
                      *ngIf="form.get('selfScheduling.isLimitNoOfCancelAppointments')?.value">
                      <label for="maxCancelAllowed" class="form__label">Max. no. of allowed attempts</label>
                      <input type="number" [appValidationMessage]="form.get('selfScheduling.maxCancelAllowed')"
                        [errorMessages]="{ required: 'Max allowed attempt  is required'}" name="maxCancelAllowed"
                        formControlName="maxCancelAllowed" class="form__control" pInputText maxlength="100" />
                      <span>(Ex: 3)</span>
                    </div>
                  </div>
                </ng-container>
              </div>
              <div class="form__group">
                <div class="input-edit-table form__checkbox-outer">
                  <p-checkbox name="isRescheduleAllowed" formControlName="isRescheduleAllowed" binary="true"
                    label="Reschedule Appointment" inputId="isRescheduleAllowed"></p-checkbox>
                  <label class="checkbox-text" for="isRescheduleAllowed">Reschedule Appointment</label>
                </div>

                <div class="appointment-block-box">
                  <ng-container *ngIf="form.get('selfScheduling.isRescheduleAllowed')?.value">
                    <div class="form__group">
                      <label for="isLimitNoOfRescheduleAppointments" class="form__label">Limit no. of attempts</label>
                      <div class="radios">
                        <div class="input-edit-table form__radio-outer">
                          <p-radioButton name="isLimitNoOfRescheduleAppointments"
                            formControlName="isLimitNoOfRescheduleAppointments" [value]="true" label="Yes"
                            inputId="attemptsYes">
                          </p-radioButton>
                          <label class="radio-button-text" for="attemptsYes">(Fixed)</label>

                        </div>
                        <div class="input-edit-table form__radio-outer">
                          <p-radioButton name="isLimitNoOfRescheduleAppointments"
                            formControlName="isLimitNoOfRescheduleAppointments" [value]="false" label="No"
                            inputId="attemptsNo">
                          </p-radioButton>
                          <label class="radio-button-text" for="attemptsNo">(Unlimited)</label>
                        </div>
                      </div>
                    </div>
                    <div class="form__group allowed"
                      *ngIf="form.get('selfScheduling.isLimitNoOfRescheduleAppointments')?.value">
                      <label for="maxRescheduleAllowed" class="form__label">Max. no. of allowed attempts</label>
                      <input type="number" [appValidationMessage]="form.get('selfScheduling.maxRescheduleAllowed')"
                        [errorMessages]="{ required: 'Max allowed attempt is required'}" name="maxRescheduleAllowed"
                        formControlName="maxRescheduleAllowed" class="form__control" pInputText maxlength="100" />
                      <span>(Ex: 3)</span>
                    </div>
                  </ng-container>

                  <div class="form__group rescheduling-appt">
                    <label for="isRescheduleRemoteAppointmentType" class="form__label">Default appointment options
                      while
                      rescheduling</label>
                    <div class="input-edit-table form__checkbox-outer">
                      <p-checkbox name="isRescheduleRemoteAppointmentType"
                        formControlName="isRescheduleRemoteAppointmentType" binary="true" label="Remote"
                        inputId="isRescheduleRemoteAppointmentType"></p-checkbox>
                      <label class="checkbox-text"
                        for="isRescheduleRemoteAppointmentType">({{optionalOnlineLabel}})</label>
                    </div>
                    <div class="input-edit-table form__checkbox-outer">
                      <p-checkbox name="isRescheduleFacilityAppointmentType"
                        formControlName="isRescheduleFacilityAppointmentType" binary="true" label="Facility"
                        inputId="isRescheduleFacilityAppointmentType"></p-checkbox>
                      <label class="checkbox-text"
                        for="isRescheduleFacilityAppointmentType">({{optionalFacilityLabel}})</label>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="self-scheduling-outer__customize-configurations">
        <h2>Customize Configuration Setup Process</h2>
        <div class="form__group full-width" formGroupName="custom">
          <label for="isCustomConfig" class="form__label">Do you want to configure self-scheduling options based on
            specific parameters of the sales order?</label>
          <div class="radios">
            <span class="form__radio-outer">
              <p-radioButton name="isCustomConfig" formControlName="isCustomConfig" [value]="true"
                inputId="configureYes" label="Yes"></p-radioButton>
              <label class="radio-button-text" for="configureYes">Yes</label>
            </span>
            <span class="form__radio-outer">
              <p-radioButton name="isCustomConfig" formControlName="isCustomConfig" [value]="false"
                inputId="configureNo" label="No"></p-radioButton>
              <label class="radio-button-text" for="configureNo">No</label>
            </span>
          </div>
          <small style="padding-top: 1rem;">Note: A maximum of 5 configurations can be created.</small>
        </div>

        <ng-container *ngIf="form.get('custom.isCustomConfig')?.value">

          <div class="self-scheduling-outer__preview-btns">
            <a href="javascript:void(0);" class="btn btn--primary" (click)="openSidebar(null)">
              <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M20 10.3053C20 12.9575 18.9464 15.501 17.0711 17.3764C15.1957 19.2517 12.6522 20.3053 10 20.3053C7.34784 20.3053 4.8043 19.2517 2.92893 17.3764C1.05357 15.501 0 12.9575 0 10.3053C0 7.65313 1.05357 5.10959 2.92893 3.23423C4.8043 1.35887 7.34784 0.305298 10 0.305298C12.6522 0.305298 15.1957 1.35887 17.0711 3.23423C18.9464 5.10959 20 7.65313 20 10.3053ZM10.625 5.9303C10.625 5.76454 10.5592 5.60557 10.4419 5.48836C10.3247 5.37115 10.1658 5.3053 10 5.3053C9.83424 5.3053 9.67527 5.37115 9.55806 5.48836C9.44085 5.60557 9.375 5.76454 9.375 5.9303V9.6803H5.625C5.45924 9.6803 5.30027 9.74615 5.18306 9.86336C5.06585 9.98057 5 10.1395 5 10.3053C5 10.4711 5.06585 10.63 5.18306 10.7472C5.30027 10.8645 5.45924 10.9303 5.625 10.9303H9.375V14.6803C9.375 14.8461 9.44085 15.005 9.55806 15.1222C9.67527 15.2395 9.83424 15.3053 10 15.3053C10.1658 15.3053 10.3247 15.2395 10.4419 15.1222C10.5592 15.005 10.625 14.8461 10.625 14.6803V10.9303H14.375C14.5408 10.9303 14.6997 10.8645 14.8169 10.7472C14.9342 10.63 15 10.4711 15 10.3053C15 10.1395 14.9342 9.98057 14.8169 9.86336C14.6997 9.74615 14.5408 9.6803 14.375 9.6803H10.625V5.9303Z"
                  fill="white" />
              </svg>
              Create Configuration
            </a>
            <app-dynamic-sidebar class="configuration-sidebar-popup"></app-dynamic-sidebar>
          </div>

          <div class="self-scheduling-outer__configuration-table">
            <div class="configuration-table-header">
              <h3>Self-scheduling Portal Configuration</h3>
              <!-- <a (click)="openSidebar(null)">
                <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M22 11.3053C22 14.2227 20.8411 17.0206 18.7782 19.0835C16.7153 21.1464 13.9174 22.3053 11 22.3053C8.08262 22.3053 5.28473 21.1464 3.22183 19.0835C1.15893 17.0206 0 14.2227 0 11.3053C0 8.38792 1.15893 5.59002 3.22183 3.52712C5.28473 1.46422 8.08262 0.305298 11 0.305298C13.9174 0.305298 16.7153 1.46422 18.7782 3.52712C20.8411 5.59002 22 8.38792 22 11.3053ZM11.6875 6.4928C11.6875 6.31046 11.6151 6.13559 11.4861 6.00666C11.3572 5.87773 11.1823 5.8053 11 5.8053C10.8177 5.8053 10.6428 5.87773 10.5139 6.00666C10.3849 6.13559 10.3125 6.31046 10.3125 6.4928V10.6178H6.1875C6.00516 10.6178 5.8303 10.6902 5.70136 10.8192C5.57243 10.9481 5.5 11.123 5.5 11.3053C5.5 11.4876 5.57243 11.6625 5.70136 11.7914C5.8303 11.9204 6.00516 11.9928 6.1875 11.9928H10.3125V16.1178C10.3125 16.3001 10.3849 16.475 10.5139 16.6039C10.6428 16.7329 10.8177 16.8053 11 16.8053C11.1823 16.8053 11.3572 16.7329 11.4861 16.6039C11.6151 16.475 11.6875 16.3001 11.6875 16.1178V11.9928H15.8125C15.9948 11.9928 16.1697 11.9204 16.2986 11.7914C16.4276 11.6625 16.5 11.4876 16.5 11.3053C16.5 11.123 16.4276 10.9481 16.2986 10.8192C16.1697 10.6902 15.9948 10.6178 15.8125 10.6178H11.6875V6.4928Z"
                    fill="#6F64A7" />
                </svg>
                Create
              </a> -->
            </div>

            <div class="configuration-table-content">
              <p-table #nsdl class="table-outer" responsiveLayout="scroll" [value]="configs">
                <ng-template pTemplate="header">
                  <tr>
                    <th pFrozenColumn class="table-outer__th">Configuration Name</th>
                    <th pFrozenColumn class="table-outer__th">Parameters</th>
                    <th class="table-outer__th">Expected Output</th>
                    <th pFrozenColumn alignFrozen="right" class="table-outer__th table-dot-column" width="120">Actions
                    </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-config>
                  <tr>
                    <td pFrozenColumn class="table-outer__td">{{config?.name}}</td>
                    <td pFrozenColumn class="table-outer__td">
                      {{config?.jsonValue?.classificationIds==null?'':'Classification ,'}}
                      {{config?.jsonValue?.branchIds==null?'':' Branch ,'}}
                      {{config?.jsonValue?.insuranceIds==null?'':' Insurance'}}
                    </td>

                    <td class="table-outer__td">
                      <div class="invitation">
                        <span><label>Invitation Template:</label> {{ getTemplateName(config?.jsonValue?.templateId) }}
                        </span>
                        <span><label>Type of
                            appointment:</label>{{config?.jsonValue?.isFreshRemoteTypeAppointment?'Remote':''}},
                          {{config?.jsonValue?.isFreshFacilityTypeAppointment?'Facility':''}}</span>
                        <span>
                          <label>Post appointment options:</label>
                          {{ config?.jsonValue?.isLimitNoOfCancelAppointments ? ('Max Allowed: ' +
                          config?.jsonValue?.maxCancelAllowed) :
                          'Cancel (Unlimited)' }}
                        </span>
                      </div>
                    </td>

                    <td pFrozenColumn alignFrozen="right" class="table-outer__td table-dot-column">
                      <div class="action-column">
                        <a class="actionmenu-btn" href="javascript:void(0)" (click)="therapistsAction.toggle($event)">
                          <svg _ngcontent-nwa-c189="" width="21" height="5" viewBox="0 0 21 5" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <circle _ngcontent-nwa-c189="" cx="2.5" cy="2.5" r="2.5" fill="#707070"></circle>
                            <circle _ngcontent-nwa-c189="" cx="10.5" cy="2.5" r="2.5" fill="#707070"></circle>
                            <circle _ngcontent-nwa-c189="" cx="18.5" cy="2.5" r="2.5" fill="#707070"></circle>
                          </svg>
                        </a>
                      </div>
                      <p-overlayPanel [dismissable]="true" appendTo="body" class="table-action-popup table-right-action"
                        #therapistsAction styleClass="self-scheduling-action-menu">
                        <ul class="quick-link-menu" style="min-width: 300px;">
                          <li>
                            <a href="javascript:void(0)" class="edit-row" (click)="previewConfig(config)">
                              <svg width="18" height="14" viewBox="0 0 18 14" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M11.7818 7.00002C11.7818 8.42433 10.6272 9.57889 9.20293 9.57889C7.77862 9.57889 6.62402 8.42433 6.62402 7.00002C6.62402 5.5757 7.77862 4.42114 9.20293 4.42114C10.6272 4.42114 11.7818 5.5757 11.7818 7.00002Z"
                                  stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                  d="M1 7.00004C2.09539 3.51244 5.35362 0.982666 9.2027 0.982666C13.0518 0.982666 16.31 3.51246 17.4054 7.00004C16.31 10.4876 13.0518 13.0174 9.2027 13.0174C5.35361 13.0174 2.09538 10.4876 1 7.00004Z"
                                  stroke="black" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                              Preview Configuration
                            </a>
                          </li>
                          <li>
                            <a href="javascript:void(0)" class="delete-row" (click)="delete(config?.id)">
                              <svg width="14" height="16" viewBox="0 0 14 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M5.40909 3H8.59091C8.59091 2.5856 8.4233 2.18817 8.12494 1.89515C7.82659 1.60212 7.42194 1.4375 7 1.4375C6.57806 1.4375 6.17341 1.60212 5.87506 1.89515C5.5767 2.18817 5.40909 2.5856 5.40909 3ZM4.45455 3C4.45455 2.33696 4.72273 1.70107 5.20009 1.23223C5.67746 0.763392 6.3249 0.5 7 0.5C7.6751 0.5 8.32254 0.763392 8.79991 1.23223C9.27727 1.70107 9.54545 2.33696 9.54545 3H13.5227C13.6493 3 13.7707 3.04939 13.8602 3.13729C13.9497 3.2252 14 3.34443 14 3.46875C14 3.59307 13.9497 3.7123 13.8602 3.80021C13.7707 3.88811 13.6493 3.9375 13.5227 3.9375H12.6891L11.9146 13.0644C11.8583 13.7283 11.55 14.3472 11.0508 14.7984C10.5516 15.2495 9.89801 15.5 9.21964 15.5H4.78036C4.10199 15.5 3.44842 15.2495 2.94923 14.7984C2.45004 14.3472 2.14171 13.7283 2.08536 13.0644L1.31091 3.9375H0.477273C0.350692 3.9375 0.229296 3.88811 0.13979 3.80021C0.0502839 3.7123 0 3.59307 0 3.46875C0 3.34443 0.0502839 3.2252 0.13979 3.13729C0.229296 3.04939 0.350692 3 0.477273 3H4.45455ZM3.03673 12.9862C3.07312 13.4159 3.27258 13.8164 3.59555 14.1084C3.91852 14.4003 4.34141 14.5624 4.78036 14.5625H9.21964C9.65859 14.5624 10.0815 14.4003 10.4045 14.1084C10.7274 13.8164 10.9269 13.4159 10.9633 12.9862L11.732 3.9375H2.26864L3.03673 12.9862ZM5.56818 6.125C5.69476 6.125 5.81616 6.17439 5.90566 6.26229C5.99517 6.3502 6.04545 6.46943 6.04545 6.59375V11.9062C6.04545 12.0306 5.99517 12.1498 5.90566 12.2377C5.81616 12.3256 5.69476 12.375 5.56818 12.375C5.4416 12.375 5.32021 12.3256 5.2307 12.2377C5.14119 12.1498 5.09091 12.0306 5.09091 11.9062V6.59375C5.09091 6.46943 5.14119 6.3502 5.2307 6.26229C5.32021 6.17439 5.4416 6.125 5.56818 6.125ZM8.90909 6.59375C8.90909 6.46943 8.85881 6.3502 8.7693 6.26229C8.6798 6.17439 8.5584 6.125 8.43182 6.125C8.30524 6.125 8.18384 6.17439 8.09434 6.26229C8.00483 6.3502 7.95455 6.46943 7.95455 6.59375V11.9062C7.95455 12.0306 8.00483 12.1498 8.09434 12.2377C8.18384 12.3256 8.30524 12.375 8.43182 12.375C8.5584 12.375 8.6798 12.3256 8.7693 12.2377C8.85881 12.1498 8.90909 12.0306 8.90909 11.9062V6.59375Z"
                                  fill="black" />
                              </svg>
                              Delete Configuration
                            </a>
                          </li>
                          <li>
                            <a href="javascript:void(0)" class="delete-row" (click)="clone(config)">
                              <svg width="15" height="16" viewBox="0 0 15 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M1.07143 1.57143H9.64286V3.71429H10.7143V1.57143C10.7143 1.28727 10.6014 1.01475 10.4005 0.813814C10.1995 0.612882 9.92702 0.5 9.64286 0.5H1.07143C0.787268 0.5 0.514746 0.612882 0.313814 0.813814C0.112882 1.01475 0 1.28727 0 1.57143V10.1429C0 10.427 0.112882 10.6995 0.313814 10.9005C0.514746 11.1014 0.787268 11.2143 1.07143 11.2143H3.21429V10.1429H1.07143V1.57143Z"
                                  fill="black" />
                                <path
                                  d="M13.928 4.78564H5.35658C5.07242 4.78564 4.7999 4.89853 4.59897 5.09946C4.39804 5.30039 4.28516 5.57291 4.28516 5.85707V14.4285C4.28516 14.7127 4.39804 14.9852 4.59897 15.1861C4.7999 15.387 5.07242 15.4999 5.35658 15.4999H13.928C14.2122 15.4999 14.4847 15.387 14.6856 15.1861C14.8866 14.9852 14.9994 14.7127 14.9994 14.4285V5.85707C14.9994 5.57291 14.8866 5.30039 14.6856 5.09946C14.4847 4.89853 14.2122 4.78564 13.928 4.78564ZM13.928 14.4285H5.35658V5.85707H13.928V14.4285Z"
                                  fill="black" />
                                <path
                                  d="M9.10728 13.3573H10.1787V10.6787H12.8573V9.60728H10.1787V6.92871H9.10728V9.60728H6.42871V10.6787H9.10728V13.3573Z"
                                  fill="black" />
                              </svg>

                              Clone & Create New Configuration
                            </a>
                          </li>
                          <li>
                            <a href="javascript:void(0)" class="delete-row" (click)="openSidebar(config)">
                              <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_18940_7877)">
                                  <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M0 3.20005C0 2.08005 0 1.52005 0.218 1.09005C0.41 0.714047 0.716 0.408047 1.092 0.216047C1.52 -0.00195311 2.08 -0.00195312 3.202 -0.00195312H3.802C4.922 -0.00195312 5.482 -0.00195311 5.912 0.216047C6.288 0.408047 6.594 0.714047 6.786 1.09005C7.004 1.51805 7.004 2.07805 7.004 3.20005V3.80005C7.004 4.92005 7.004 5.48005 6.786 5.91005C6.59426 6.28635 6.28831 6.5923 5.912 6.78405C5.484 7.00205 4.924 7.00205 3.802 7.00205H3.202C2.082 7.00205 1.522 7.00205 1.092 6.78405C0.715693 6.5923 0.409744 6.28635 0.218 5.91005C0 5.48205 0 4.92205 0 3.80005V3.20005ZM3.2 1.00005H3.8C4.377 1.00005 4.749 1.00005 5.03 1.02405C5.302 1.04605 5.402 1.08405 5.452 1.10905C5.64 1.20505 5.793 1.35805 5.889 1.54605C5.914 1.59605 5.952 1.69605 5.974 1.96805C5.997 2.25105 5.998 2.62405 5.998 3.19805V3.79805C5.998 4.37505 5.998 4.74705 5.974 5.02805C5.952 5.30005 5.914 5.40005 5.889 5.45005C5.79313 5.6382 5.64015 5.79117 5.452 5.88705C5.402 5.91205 5.302 5.95005 5.03 5.97205C4.747 5.99505 4.374 5.99605 3.8 5.99605H3.2C2.623 5.99605 2.251 5.99605 1.97 5.97205C1.698 5.95005 1.598 5.91205 1.548 5.88705C1.35985 5.79117 1.20687 5.6382 1.111 5.45005C1.086 5.40005 1.048 5.30005 1.026 5.02805C1.00316 4.61847 0.995157 4.2082 1.002 3.79805V3.19805C1.002 2.62105 1.002 2.24905 1.026 1.96805C1.048 1.69605 1.086 1.59605 1.111 1.54605C1.207 1.35805 1.36 1.20505 1.548 1.10905C1.598 1.08405 1.698 1.04605 1.97 1.02405C2.253 1.00005 2.626 1.00005 3.2 1.00005ZM9 12.2C9 11.08 9 10.52 9.218 10.09C9.41 9.71405 9.716 9.40805 10.092 9.21605C10.52 8.99805 11.08 8.99805 12.202 8.99805H12.802C13.922 8.99805 14.482 8.99805 14.912 9.21605C15.288 9.40805 15.594 9.71405 15.786 10.09C16.004 10.518 16.004 11.078 16.004 12.2V12.8C16.004 13.92 16.004 14.48 15.786 14.91C15.5943 15.2864 15.2883 15.5923 14.912 15.784C14.484 16.002 13.924 16.002 12.802 16.002H12.202C11.082 16.002 10.522 16.002 10.092 15.784C9.71569 15.5923 9.40974 15.2864 9.218 14.91C9 14.482 9 13.922 9 12.8V12.2ZM12.8 10C13.377 10 13.749 10 14.03 10.024C14.302 10.046 14.402 10.084 14.452 10.109C14.64 10.205 14.793 10.358 14.889 10.546C14.914 10.596 14.952 10.696 14.974 10.968C14.997 11.251 14.998 11.624 14.998 12.198V12.798C14.998 13.375 14.998 13.747 14.974 14.028C14.952 14.3 14.914 14.4 14.889 14.45C14.7931 14.6382 14.6402 14.7912 14.452 14.887C14.402 14.912 14.302 14.95 14.03 14.972C13.747 14.995 13.374 14.996 12.8 14.996H12.2C11.623 14.996 11.251 14.996 10.97 14.972C10.698 14.95 10.598 14.912 10.548 14.887C10.3598 14.7912 10.2069 14.6382 10.111 14.45C10.086 14.4 10.048 14.3 10.026 14.028C10.0032 13.6185 9.99516 13.2082 10.002 12.798V12.198C10.002 11.621 10.002 11.249 10.026 10.968C10.048 10.696 10.086 10.596 10.111 10.546C10.207 10.358 10.36 10.205 10.548 10.109C10.598 10.084 10.698 10.046 10.97 10.024C11.253 10.001 11.626 10 12.2 10H12.8Z"
                                    fill="black" />
                                  <path
                                    d="M8.00033 2.5C8.00033 2.36739 8.05301 2.24021 8.14678 2.14645C8.24055 2.05268 8.36772 2 8.50033 2H10.5003C11.1634 2 11.7993 2.26339 12.2681 2.73223C12.7369 3.20107 13.0003 3.83696 13.0003 4.5V6.29L14.1503 5.14C14.2446 5.04892 14.3709 4.99852 14.502 4.99966C14.6331 5.0008 14.7585 5.05339 14.8512 5.14609C14.9439 5.23879 14.9965 5.3642 14.9977 5.4953C14.9988 5.6264 14.9484 5.7527 14.8573 5.847L12.8573 7.847C12.7636 7.94074 12.6364 7.99339 12.5038 7.99339C12.3713 7.99339 12.2441 7.94074 12.1503 7.847L10.1503 5.847C10.0593 5.7527 10.0089 5.6264 10.01 5.4953C10.0111 5.3642 10.0637 5.23879 10.1564 5.14609C10.2491 5.05339 10.3745 5.0008 10.5056 4.99966C10.6367 4.99852 10.763 5.04892 10.8573 5.14L12.0073 6.29V4.5C12.0073 4.10218 11.8493 3.72064 11.568 3.43934C11.2867 3.15804 10.9052 3 10.5073 3H8.50733C8.37472 3 8.24755 2.94732 8.15378 2.85355C8.06001 2.75979 8.00733 2.63261 8.00733 2.5H8.00033ZM3.31033 8.04C3.36996 8.01532 3.4338 8.00242 3.49833 8.002H3.50433C3.63599 8.00256 3.76212 8.05502 3.85533 8.148L5.85533 10.148C5.94641 10.2423 5.99681 10.3686 5.99567 10.4997C5.99453 10.6308 5.94195 10.7562 5.84924 10.8489C5.75654 10.9416 5.63113 10.9942 5.50003 10.9953C5.36893 10.9965 5.24263 10.9461 5.14833 10.855L3.99833 9.705V11.495C3.99833 11.8928 4.15637 12.2744 4.43767 12.5557C4.71898 12.837 5.10051 12.995 5.49833 12.995H7.49833C7.63094 12.995 7.75812 13.0477 7.85189 13.1414C7.94565 13.2352 7.99833 13.3624 7.99833 13.495C7.99833 13.6276 7.94565 13.7548 7.85189 13.8486C7.75812 13.9423 7.63094 13.995 7.49833 13.995H5.49833C4.83529 13.995 4.19941 13.7316 3.73057 13.2628C3.26172 12.7939 2.99833 12.158 2.99833 11.495V9.705L1.84833 10.855C1.75403 10.9461 1.62773 10.9965 1.49663 10.9953C1.36553 10.9942 1.24013 10.9416 1.14742 10.8489C1.05472 10.7562 1.00213 10.6308 1.001 10.4997C0.999856 10.3686 1.05025 10.2423 1.14133 10.148L3.14133 8.148C3.18764 8.10137 3.24269 8.06433 3.30333 8.039L3.31033 8.04Z"
                                    fill="black" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_18940_7877">
                                    <rect width="16" height="16" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                              Edit
                            </a>
                          </li>
                        </ul>
                      </p-overlayPanel>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </ng-container>

      </div>
    </div>

    <div class="btns">
      <button class="btn btn--primary mb-0" routerLink="/admin/settings/application" (click)="save()">Save</button>
      <button class="btn btn--secondary mb-0" routerLink="/admin/settings">Cancel</button>
    </div>
  </form>
</div>

<div class="loader-block" *ngIf="loading">
  <p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="8" fill="#ffffff">
  </p-progressSpinner>
</div>



<p-dialog [(visible)]="showMaxConfigLimitPopup" appendTo="body" [modal]="true" [responsive]="true">
  <div class="configuration-popup-outer">
    <div class="configuration-popup-outer__title">
      <h2>
        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9 0.5C4.032 0.5 0 4.532 0 9.5C0 14.468 4.032 18.5 9 18.5C13.968 18.5 18 14.468 18 9.5C18 4.532 13.968 0.5 9 0.5ZM9.9 14H8.1V8.6H9.9V14ZM9.9 6.8H8.1V5H9.9V6.8Z"
            fill="#484848" />
        </svg>
        Configuration max limit reached.
      </h2>

    </div>
    <div class="configuration-popup-outer__content confirm-availability">
      <div class="partial-duplicate">
        <p class="error">
          You can not add more than 5 custom configurations.</p>
      </div>

    </div>

    <div class="configuration-popup-outer__btn-block">
      <a class="btn btn--secondary clear-filter" (click)="onMaxLimitCancel()">Ok</a>
    </div>
  </div>
</p-dialog>